// extracted by mini-css-extract-plugin
export default {"container":"Kk-z","blurb":"Lk-z","links":"Mk-z"};